'use strict';

class NotificationsInfoController {
  constructor($scope,
              $rootScope,
              $filter,
              $state,
              $stateParams,
              $q,
              $log,
              utils,
              config,
              OrganizationService,
              LocationsService,
              DevicesService,
              UsersService,
              BotsService,
              ToastsService) {

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_NOTIFICATION_LOCAL_STORAGE_KEY = 'Selected-Notification';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
    const SELECTED_DEVICE_LOCAL_STORAGE_KEY = 'Selected-Device';
    const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';
    const SELECTED_BOT_LOCAL_STORAGE_KEY = 'Selected-Bot';

    // region Define fields

    $scope.chooseOrg = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.event = utils.getStorageItem(SELECTED_NOTIFICATION_LOCAL_STORAGE_KEY);

    // Where we came from to this page (view)
    $scope.selection = ($state.params && $state.params.from) || 'organization';

    // Timezone form the location
    if ($scope.selection === 'location') {
      $scope.locationInfo = utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);
      $scope.timezone = $scope.locationInfo.timezone ? $scope.locationInfo.timezone.id : moment.tz.guess();
      $scope.locationTimeZoneOffset = moment().tz($scope.timezone).format('Z');
    }

    $scope.statuses = config.getConfigByKey('narrativeStatuses');
    $scope.selectedStatusId = $scope.event.status;
    const targetKeys = config.getConfigByKey('narrativeTargetKeys');
    const narrativeTypes = config.getConfigByKey('narrativeTypes');

    // Separate API calls
    let relationsLoaded = false;

    // Navigaiton Tabs
    $scope.tabs = [
      {
        id: 'details',
        name: $t('form.details'),
        icon: 'far fa-file-alt'
      }, {
        id: 'relations',
        name: $t('bots.relations'),
        icon: 'far fa-link'
      },
      {
        id: 'properties',
        name: $t('notifications.info.props'),
        icon: 'far fa-drafting-compass'
      }
    ];

    $scope.dateFormat = $t('datetime.events.timestamp');
    $scope.dateFormatShort = $t('datetime.mdyHMS12');

    // Put on scope only the stuff we really need there
    angular.extend($scope, {
      back: back,

      // Details Tab
      isNarrativeChanged: isNarrativeChanged,
      updateNarrative: updateNarrative,
      getEventTitle: getEventTitle,

      // Relations Tab
      generateAddress: generateAddress,
      isAdminUser: isAdminUser,
      viewLocation: viewLocation,
      viewDevice: viewDevice,
      viewUser: viewUser,
      viewBot: viewBot,

      // Properties Tab
      parsePythonProperty: parsePythonProperty
    });

    // endregion

    initPage();

    // Please, no code execution below this line - only function definitions
    // ---------------------------------------------------------------------

    // #region Main Methods --------------------------------

    function initPage() {

      // API calls separation at different navigation tabs
      $scope.$watch('activeTab', function(newValue, oldValue) {
        switch (newValue) {
          case 'relations':
            if (!relationsLoaded) {
              initRelationsTab();
            }
            break;
        }
      });

      getNarrativeDetails();
    }

    function back() {
      $scope.loading = false;
      $scope.relationsLoading = false;
      if ($scope.selection === 'location') {
        $state.go('main.locations.edit', { tab: 'events' });
        $rootScope.$emit('refreshChooseMenuEvent', 'locations');
      } else {
        $state.go('main.notifications.list');
      }
    }

    function getNarrativeDetails() {
      if (!$scope.event) {
        return;
      }
      $scope.loading = true;
      $scope.relationsLoading = true;
      let params = {
        narrativeId: $scope.event.id
      };

      if ($scope.selection === 'location') {
        return LocationsService.getNarratives($scope.event.locationId, params)
          .then(data => {
            if (!data.narratives || data.narratives.length === 0) {
              $scope.loading = false;
              return;
            }
            processNarrative(data.narratives[0]);
          }, err => {
            $scope.loading = false;
            $scope.relationsLoading = false;
            utils.handleApiError(err);
          });
      }

      if ($scope.event.status === 1) {
        params.status = 1;
      }

      return OrganizationService.getOrganizationNarratives($scope.chooseOrg.id, params)
        .then(data => {
          if (!data.narratives || data.narratives.length === 0) {
            $scope.loading = false;
            return;
          }
          processNarrative(data.narratives[0]);
        }, err => {
          $scope.loading = false;
          $scope.relationsLoading = false;
          utils.handleApiError(err);
        });
    }

    function processNarrative(data) {
      $scope.event = data;
      $scope.adminComment = data.target && data.target.comment ? data.target.comment : '';
      $scope.selectedStatusId = data.status;
      $scope.narrativeProperties = collectTargetProperties();

      $scope.mapAttributes = angular.copy(data.target);

      // Gather properties for position on the map
      if (data.target && data.target['device_latitude'] && data.target['device_longitude']) {
        $scope.position = {
          latitude: data.target['device_latitude'],
          longitude: data.target['device_longitude'],
          timestamp: data.target['device_position_datetime'],
        };
      }

      return getLocationInfo();
    }

    function isNarrativeChanged() {
      let commentEqual = ($scope.event.target && $scope.event.target.comment)
        ? $scope.adminComment === $scope.event.target.comment
        : $scope.adminComment === '';
      return $scope.selectedStatusId !== $scope.event.status || !commentEqual;
    }

    /**
     * Generates title if title is missing
     */
    function getEventTitle(event) {
      if (event.title) {
        return event.title;
      }
      const narrativeType = event.narrativeType && narrativeTypes.find(type => event.narrativeType === type.id);
      return narrativeType ? $t(narrativeType.desc) : $t('events.types.unknown');
    }

    /**
     * Updates existing narratove
     */
    function updateNarrative() {
      if (!isNarrativeChanged()) {
        return;
      }

      // Update location/organization narrative type
      let narrativeScope = $scope.selection === 'location' ? 1 : 2;

      let narrativeTarget = $scope.event.target || {};
      narrativeTarget.comment = $scope.adminComment;
      let narrative = {
        status: $scope.selectedStatusId,
        target: narrativeTarget
      };

      return LocationsService.updateNarrative($scope.event.locationId, narrativeScope, narrative, $scope.event.id, $scope.event.narrativeDateMs)
        .then(data => {
          ToastsService.success();
          return back();
        }, err => {
          $scope.loading = false;
          $scope.relationsLoading = false;
          utils.handleApiError(err);
        });
    }

    // #endregion

    // #region Relations Tab Methods -----------------------

    function initRelationsTab() {
      $scope.relationsLoading = true;
      return $q.all([
        getTargetDevices(),
        getTargetUsers(),
        getBotInstance()
      ]).then(result => {
        relationsLoaded = true;
        $scope.relationsLoading = false;
        $scope.targetDevices = result[0];
        $scope.targetUsers = result[1];
        $scope.targetBotInstance = result[2];
      }).catch(err => {
        $scope.relationsLoading = false;
        $scope.relationsLoading = false;
        utils.handleApiError(err);
      });
    }

    function getLocationInfo() {
      if ($scope.selection === 'location' && $scope.locationInfo && $scope.event.locationId === $scope.locationInfo.id) {
        $scope.loading = false;
        return;
      }

      return LocationsService.getLocationInfo($scope.chooseOrg.id, $scope.event.locationId)
        .then(data => {
          $scope.loading = false;
          if (!data.locations || data.locations.length === 0) {
            $scope.locationInfo = {
              id: $scope.event.locationId,
              organizationId: $scope.event.organizationId
            };
            return;
          }
          $scope.locationInfo = data.locations.find(l => l.id === $scope.event.locationId);
        }, err => {
          $scope.loading = false;
          $scope.relationsLoading = false;
          utils.handleApiError(err);
        });
    }

    function generateAddress(location) {
      if (!location || !location.creationDateMs) {
        return $t('notifications.info.removedDesc');
      }

      let address = utils.generateAddress(location);
      if (!address) {
        return $t('common.unknown-address');
      }
      return address;
    }

    /**
     * Generate array of target devices
     */
    function getTargetDevices() {
      let targetDevices = $scope.event.target && $scope.event.target.devices
        ? angular.copy($scope.event.target.devices)
        : [];
      let targetDeviceId = $scope.event.target && $scope.event.target['device_id'];
      if (targetDeviceId) {
        return DevicesService.getDevice(targetDeviceId, $scope.event.locationId, false)
          .then(data => {
            if (data && data.device) {
              let device = data.device;
              if (device.typeAttributes && device.typeAttributes.length > 0) {
                let deviceListIcon = device.typeAttributes.filter(el => el.name === 'deviceListIcon');
                device.icon = deviceListIcon.length > 0 && deviceListIcon[0].value;
              }
              if ($scope.event.target['goal_id'] || $scope.event.target['goal_id'] === 0) {
                device.changeGoal = true;
                device.targetGoal = $scope.event.target['goal_id'];
              }
              targetDevices.push(device);
            } else {
              targetDevices.push({
                id: targetDeviceId,
                desc: $scope.event.target['description'] || null,
                changeGoal: ($scope.event.target['goal_id'] || $scope.event.target['goal_id'] === 0) ? true : false,
                targetGoal: $scope.event.target['goal_id']
              });
            }
            return $q.resolve(targetDevices);
          }, err => {
            console.log(err);
            return $q.resolve(targetDevices);
          });
      }
      return $q.resolve(targetDevices);
    }

    /**
     * Generate array of target users
     */
    function getTargetUsers() {
      let targetUsers = $scope.event.target && $scope.event.target.users ? $scope.event.target.users.map(el => {
        let tempUser = {
          id: el['user_id'],
          firstName: el['first_name'] || null,
          lastName: el['last_name'] || null,
          phone: el.phone || null
        };
        if (el.email) {
          tempUser.email = {
            email: el.email
          };
        }
        return tempUser;
      }) : [];
      let targetUserId = $scope.event.target && $scope.event.target['user_id'];
      if (targetUserId) {
        return UsersService.getUserInfo(targetUserId, $scope.chooseOrg.id)
          .then(data => {
            if (data && data.user) {
              targetUsers.push(data.user);
            } else {
              targetUsers.push({
                id: targetUserId,
                firstName: $scope.event.target['first_name'] || null,
                lastName: $scope.event.target['last_name'] || null
              });
            }
            return $q.resolve(targetUsers);
          }, err => {
            console.log(err);
            return $q.resolve(targetUsers);
          });
      }

      // For removal narratives
      if ($scope.event.user) {
        targetUsers.push($scope.event.user);
      }

      return $q.resolve(targetUsers);
    }

    /**
     * Get Bot Instance Information
     */
    function getBotInstance() {
      if (!$scope.event || !$scope.event.appInstanceId || !$scope.event.locationId) {
        return;
      }

      return BotsService.getBotInstance($scope.event.appInstanceId, void 0, $scope.event.locationId)
        .then(data => {
          if (data.bots && data.bots.length > 0) {
            return $q.resolve(data.bots[0]);
          }
        }, err => {
          $scope.loading = false;
          $scope.relationsLoading = false;
          utils.handleApiError(err);
        });
    }

    function isAdminUser(user) {
      return utils.checkAdminRights(user);
    }

    /**
     * Goto related location
     */
    function viewLocation() {
      utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, $scope.locationInfo);
      $rootScope.$emit('refreshChooseMenuEvent', 'locations');
      $state.go('main.locations.edit', {
        locationId: $scope.locationInfo.id,
        from: 'notification'
      });
    }

    /**
     * Goto related device info
     */
    function viewDevice(device, changeGoal) {
      // Parse Python params properly
      device.id = device.id || device['device_id'];
      device.typeDesc = device['type_name'] || '';

      let params = {
        from: 'notification',
        locationId: $scope.locationInfo.id
      };
      if (changeGoal) {
        params.goalId = device.targetGoal;
        params.tab = 'goals';
      }

      utils.setStorageItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY, device);
      $rootScope.$emit('refreshChooseMenuEvent', 'devices');
      $state.go('main.devices.edit', params);
    }

    /**
     * Goto related user info
     */
    function viewUser(user) {
      if (user.deleteDateMs) {
        return;
      }

      utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
      $rootScope.$emit('refreshChooseMenuEvent', 'users');
      $state.go('main.users.edit', {
        from: 'notification'
      });
    }

    /**
     * Goto related bot details
     */
    function viewBot() {
      utils.setStorageItem(SELECTED_BOT_LOCAL_STORAGE_KEY, $scope.targetBotInstance);
      $state.go('main.bots.info', {
        from: 'notification'
      });
    }

    // #endregion

    // #region Properties Tab Methods ----------------------

    /**
     * Look for Narrative "target" additional keys
     */
    function collectTargetProperties() {
      let result = [];
      if (!$scope.event.target) {
        return result;
      }

      let targetArr = Object.keys($scope.event.target);
      targetArr.forEach((value) => {
        if (!targetKeys.includes(value)) {
          result.push({
            name: value,
            value: $scope.event.target[value]
          });
        }
      });
      return result;
    }

    function parsePythonProperty(name) {
      if (!name) {
        return $t('notifications.info.unknown-prop');
      }
      return utils.parsePythonString(name);
    }

    // #endregion

  }
}

export default angular
  .module('main.notificationsInfo.controller', [])
  .controller('NotificationsInfoController', NotificationsInfoController)
  .name;
